import { ThemeLayout } from '../../front/lib/ThemeLayout';
export class Single extends ThemeLayout {
    init() {
    }
}
